import React from "react";

const PageHeader = ({
  title,
  subtitle,
  actions
}) => {

  return (

    <div className="page-header">

      <div className="page-header-content">

        <div>

          <h1 className="page-title">
            {title}
          </h1>

          {subtitle && (
            <p className="page-subtitle">
              {subtitle}
            </p>
          )}

        </div>

        {actions && (

          <div className="page-actions">

            {actions}

          </div>

        )}

      </div>

    </div>

  );

};

export default PageHeader;